<template>
  <div :style="settingsStore.colorSetup" class="webkit-fill-fix">
    <template v-if="ifShareHasExpired">
      <main class="flex h-screen border-box justify-center items-center bg-gray-100">
        <div class="bg-white border-gray-200 border w-1/2 text-center p-12 rounded-lg">
          <h2 class="text-20 text-black-60% font-semibold">{{ $t("Uchi.Share.Expired") }}</h2>
          <p class="text-black-60%">{{ $t("Uchi.Share.ExpiredSub") }}</p>
        </div>
      </main>
    </template>
    <template v-if="isPasswordRequired">
      <main class="flex h-screen border-box justify-center items-center bg-gray-100">
        <div class="bg-white border-gray-200 border w-1/2 text-center p-12 rounded-lg">
          <h2 class="text-20 text-black-60% font-semibold mb-3">{{ $t("Uchi.Password.SubmitPassword") }}</h2>
          <p class="text-12 text-black-60% mb-6">{{ $t("Uchi.Password.SubMessage") }}</p>
          <input
            v-model="password"
            class="w-60 border-t-0 border-l-0 border-r-0 border-orange-400 border-2 p-2 mb-2 text-center"
            type="password"
          />
          <div v-if="errorMessage" class="text-red-500 mt-3">
            {{ errorMessage }}
          </div>
          <div>
            <button @click="validatePassword" class="button button-primary mt-6">OK</button>
          </div>
          <div class="float-right mt-10">
            <button class="text-black-60% text-xs" @click="resendNewPassword" :disabled="isSending">
              {{ isSending ? $t("Uchi.Password.NewPasswordSend") : $t("Uchi.Password.ResendPassword") }}
            </button>
          </div>
        </div>
      </main>
    </template>
    <template v-if="!ifShareHasExpired">
      <div class="flex flex-col h-screen border-box">
        <TopPanel
          :isInstitutionSelectorVisible="false"
          :isUserInfoVisible="false"
          class="absolute inset-x-0 top-0 h-16 md:h-24"
        />

        <div class="flex-grow flex pt-16 md:pt-24 webkit-fill-fix">
          <LeftPanel :isLeftMenuVisible="false" :isDocumentSearchVisible="false" />
          <main class="flex-grow p-4 md:p-8 overflow-auto pb-20 md:pb-4" v-if="!loading">
            <router-view />
          </main>
        </div>
      </div>
      <transition name="fade">
        <div id="preloader" v-if="loading" class="flex items-center justify-center">
          <InfoSpinner></InfoSpinner>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import LeftPanel from "@/components/Navigation/LeftPanel";
import TopPanel from "@/components/Navigation/TopPanel";
import InfoSpinner from "@/components/Shared/InfoSpinner";

import { useSettingsStore } from "@/stores/settings";
import { useDocumentStore } from "@/stores/documents";

export default {
  name: "shareApp",

  data: function () {
    return {
      loading: true,
      isPasswordRequired: false,
      password: "",
      errorMessage: "",
      ifShareHasExpired: false,
      isSending: false,
      color_setup: {
        backgroundColor: "#f5f5f5"
      }
    };
  },

  setup() {
    return {
      settingsStore: useSettingsStore(),
      documentStore: useDocumentStore()
    };
  },

  async created() {
    try {
      this.loading = true;
      if (this.$route.params.shareId) {
        await this.settingsStore.loadQuickShareFromKey(this.$route.params.shareId);
      }

      this.ifShareHasExpired = false;
    } catch {
      this.ifShareHasExpired = true;
    } finally {
      if (
        !this.settingsStore.quickShareSessionToken ||
        this.settingsStore.quickShareSessionToken === "00000000-0000-0000-0000-000000000000"
      ) {
        this.isPasswordRequired = true;
      }
    }

    this.loading = false;
  },

  methods: {
    async validatePassword() {
      this.errorMessage = "";
      try {
        const result = await this.settingsStore.validatePasswordOnQuickShare(this.$route.params.shareId, this.password);

        if (!result) {
          this.errorMessage = this.$t("Uchi.Password.ErrorMessage");
          return;
        }

        await this.documentStore.loadQuickShareDocuments();
        this.isPasswordRequired = false;
      } catch (err) {
        this.errorMessage = this.$t("Uchi.Password.ErrorMessage");
      }
    },

    async resendNewPassword() {
      this.isSending = true;
      try {
        if (this.$route.params.shareId) {
          setTimeout(() => {
            this.isSending = false;
          }, 2000);
          await this.settingsStore.resendPasswordOnQuickShare(this.$route.params.shareId);
        }
      } catch (error) {
        //console.error(error);
      }
    }
  },

  components: {
    LeftPanel,
    TopPanel,
    InfoSpinner
  }
};
</script>
